import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Icon } from 'iovisit-theme/components';
import { UniversalLink } from '@plone/volto/components';

const messages = defineMessages({
  virtual_tour_link_label: {
    id: 'virtual_tour_link_label',
    defaultMessage: '360° Virtual Tour - Apri il virtual tour in una nuova tab',
  },
});

const VirtualTourLink = ({ content, showLabel }) => {
  const intl = useIntl();

  return content?.virtual_tour_link?.length > 0 ? (
    <div className="page-virtual-tour-link">
      <UniversalLink
        item={content.virtual_tour_link[0]}
        target="_blank"
        title={intl.formatMessage(messages.virtual_tour_link_label)}
      >
        <Icon prefix="fas" icon="vr-cardboard" className="icon" />
        {showLabel && (
          <span className="icon-label">
            {intl.formatMessage(messages.virtual_tour_link_label)}
          </span>
        )}
      </UniversalLink>
    </div>
  ) : (
    <></>
  );
};
export default VirtualTourLink;
